import React from 'react';

/**
 * NestedIcon Component.
 */
function NestedIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='16'
      viewBox='0 0 25 16'
      fill='none'>
      <path
        d='M1.13346 0.222168C1.50165 0.222168 1.80013 0.520645 1.80013 0.888835V6.22217C1.80013 8.7995 3.88947 10.8888 6.4668 10.8888H22.1908L19.7732 8.4713C19.5129 8.21095 19.5129 7.78894 19.7732 7.52859C20.0336 7.2683 20.4556 7.26826 20.7159 7.52859L24.2715 11.0841C24.3921 11.2048 24.4668 11.3714 24.4668 11.5555C24.4668 11.6843 24.4285 11.8034 24.3652 11.9053C24.3384 11.9487 24.3081 11.9902 24.2715 12.0269L20.7159 15.5824C20.4556 15.8427 20.0336 15.8427 19.7732 15.5824C19.5129 15.3221 19.5129 14.9 19.7732 14.6397L22.1908 12.2222H6.4668C3.15309 12.2222 0.466797 9.53588 0.466797 6.22217V0.888835C0.466797 0.520645 0.765274 0.222168 1.13346 0.222168Z'
        fill='#212328'
      />
    </svg>
  );
}

export default NestedIcon;
